import { useContext, useEffect, useState } from "react";
import { SidebarContext } from "context/SidebarContext";

const useToggleDrawer = () => {
  const [isViewMode, setIsViewMode] = useState(false);
  // const [serviceId, setServiceId] = useState("");
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [days, setDays] = useState("");
  const [latest_va_id, setLatest_va_id] = useState("");
  const [is_vehicle_alloted, set_is_vehicle_alloted] = useState("");
  const [faVendorIsAllot, setfaVendorIsAllot] = useState(false);
  const [percentage, setPercentage] = useState("");
  const [vendor_name, setVendorName] = useState("");
  const [vendor_id, setVendorId] = useState("");
  const [allId, setAllId] = useState([]);
  const [title, setTitle] = useState("");
  const [vendorAllotAction, setVendorAllotAction] = useState("");
  const [serviceBlock, setServiceBlock] = useState("");
  const [, setServiceActive] = useState("");
  const [billAmount, setBillAmount] = useState(""); // New state for billAmount
  const [vaId, setVaId] = useState(""); // New state for vaId
  const [PackageType, setPackageType] = useState("");
  const [clientArrived, setClientArrived] = useState(false);
  const [
    is_Franchise_driver_vehicle_alloted,
    set_Franchise_is_driver_vehicle_alloted,
  ] = useState("");
  const [franchiseAction, setfranchiseAction] = useState("");
  const [vendorAction, setVendorAction] = useState("");
  // The current driver_vehicle allotment's own trip_went_or_not ('1'/'2'/'0') —
  // once it's already '1' (confirmed went), the "No" option in the Trip Went
  // drawer has to disappear entirely, since a real trip already happened and
  // can't be retroactively un-happened.
  const [tripWentOrNot, setTripWentOrNot] = useState(null);
  const {
    toggleDrawer,
    isDrawerOpen,
    toggleModal,
    toggleModalBlock,
    toggleModalView,
    toggleBulkDrawer,
    isModalOpen,
    isViewModalOpen,
    serviceId,
    setServiceId,
  } = useContext(SidebarContext);

  const handleUpdate = (id, days, percentage) => {
    setServiceId(id);
    toggleDrawer();
    setDays(days);
    setPercentage(percentage);
  };

  const handleVendorUpdate = (
    id,
    start_date,
    end_date,
    package_type,
    latest_va_id,
    vendorAllotAction
  ) => {
    //  console.log("Received package_type in handleVendorUpdate:", package_type);
    setServiceId(id);
    setStartDate(start_date);
    setEndDate(end_date);
    setPackageType(package_type);
    setLatest_va_id(latest_va_id);
    setVendorAllotAction(vendorAllotAction);
    toggleDrawer();
  };

  //  console.log("Received package_type in handleVendorUpdate:", package_type);
  const handleFranchiseUpdate = (
    id,
    start_date,
    end_date,
    vendor_name,
    vendor_id,
    days_count,
    latest_va_id,
    package_type,
    is_vendor_alloted,
    is_driver_vehicle_alloted,
    franchiseAction,
    clientArrived,
    trip_went_or_not
  ) => {
    setServiceId(id);
    setStartDate(start_date);
    setVendorName(vendor_name);
    setDays(days_count);
    setVendorId(vendor_id);
    setEndDate(end_date);
    setLatest_va_id(latest_va_id);
    setPackageType(package_type);
    setfaVendorIsAllot(is_vendor_alloted);
    set_Franchise_is_driver_vehicle_alloted(is_driver_vehicle_alloted);
    setfranchiseAction(franchiseAction);
    setClientArrived(clientArrived);
    setTripWentOrNot(trip_went_or_not ?? null);

    toggleDrawer();
  };

  const handleModifyUpdate = (
    id,
    start_date,
    end_date,
    vendor_name,
    vendor_id,
    days_count,
    latest_va_id,
    package_type,
    is_vehicle_alloted,
    vendorAction,
    clientArrived,
    trip_went_or_not
  ) => {
    setServiceId(id);
    setStartDate(start_date);
    setVendorName(vendor_name);
    setDays(days_count);
    setVendorId(vendor_id);
    setEndDate(end_date);
    setLatest_va_id(latest_va_id);
    setPackageType(package_type);
    set_is_vehicle_alloted(is_vehicle_alloted);
    setVendorAction(vendorAction);
    setClientArrived(clientArrived);
    setTripWentOrNot(trip_went_or_not ?? null);

    toggleDrawer();
  };

  // New handler to pass billAmount and vaId
  const handleAddOrModify = (id, bill_amount, va_id) => {
    setServiceId(id);
    setBillAmount(bill_amount);
    setVaId(va_id);
    toggleDrawer();
  };

  const handleUpdateMany = (id) => {
    setAllId(id);
    toggleBulkDrawer();
  };

  const handleModalOpen = (id, title) => {
    setServiceId(id);
    toggleModal();
    setTitle(title);
  };
  const handleView = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };
  const handleJobDetails = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };
  const handleMenuDetails = (id_menu, title) => {
    setServiceId(id_menu);
    toggleModalView();
    setTitle(title);
  };

  const handleViewOrder = (id, title) => {
    setServiceId(id);
    toggleModalView();
    setTitle(title);
  };

  const handleBlock = (id, block, title) => {
    setServiceId(id);
    setServiceBlock(block);
    toggleModalBlock();
    setTitle(title);
  };
  const handleActive = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  const handleMenu = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  const handleContact = (id, active, title) => {
    setServiceId(id);
    setServiceActive(active);
    toggleModalBlock();
    setTitle(title);
  };
  useEffect(() => {
    if (!isDrawerOpen) {
      setIsViewMode(false);
      setVendorAction("");
      setfranchiseAction("");
      setVendorAllotAction("");
      setClientArrived(false);
      setTripWentOrNot(null);
    }
    if (!isDrawerOpen && !isModalOpen) {
      setServiceId("");
    }
  }, [isDrawerOpen, isModalOpen]);

  useEffect(() => {
    if (!isViewModalOpen) {
      setServiceId("");
    }
  }, [isViewModalOpen]);

  const handleDeleteMany = async (id, products) => {
    setAllId(id);
    toggleModal();
    setTitle("Selected Products");
  };
  // console.log(PackageType)
  return {
    title,
    allId,
    serviceId,
    start_date,
    end_date,
    latest_va_id,
    days,
    percentage,
    setPercentage,
    setDays,
    vendor_name,
    vendor_id,
    billAmount, // Expose billAmount state
    vaId, // Expose vaId state
    setVendorName,
    setVendorId,
    serviceBlock,
    handleUpdate,
    setServiceId,
    setServiceBlock,
    setServiceActive,
    handleModalOpen,
    handleDeleteMany,
    handleUpdateMany,
    handleVendorUpdate,
    handleFranchiseUpdate,
    handleModifyUpdate,
    handleAddOrModify, // Expose new handler
    setStartDate,
    setEndDate,
    handleView,
    handleJobDetails,
    handleMenuDetails,
    handleViewOrder,
    handleBlock,
    handleActive,
    handleMenu,
    handleContact,
    setIsViewMode,
    isViewMode,
    // updateServiceId,
    PackageType,
    is_vehicle_alloted,
    faVendorIsAllot,
    is_Franchise_driver_vehicle_alloted,
    franchiseAction,
    vendorAction,
    vendorAllotAction,
    clientArrived,
    tripWentOrNot
  };
};

export default useToggleDrawer;
